import { useState, useEffect } from 'react';
import api from '../api';
import { TimeSeriesChart, CameraCompareChart } from '../components/Charts';
import toast from 'react-hot-toast';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [chartData, setChartData] = useState(null);
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get('/clients').then(r => setClients(r.data)).catch(() => {}); }, []);
  useEffect(() => { loadData(); }, [selectedClient]);

  async function loadData() {
    setLoading(true);
    try {
      const p = selectedClient ? `?clientId=${selectedClient}` : '';
      const [s, c] = await Promise.all([api.get(`/reports/summary${p}`), api.get(`/reports/data${p}${p ? "&" : "?"}groupBy=day`)]);
      setStats(s.data); setChartData(c.data);
    } catch { toast.error('Klaida kraunant duomenis'); }
    finally { setLoading(false); }
  }

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div><div className="page-title">Administravimo apžvalga</div><div className="page-subtitle">Axis Object Analytics – visi klientai</div></div>
        <select className="form-select" style={{ width: 220 }} value={selectedClient} onChange={e => setSelectedClient(e.target.value)}>
          <option value="">Visi klientai</option>
          {clients.map(c => <option key={c.id} value={c.id}>{c.company || c.name}</option>)}
        </select>
      </div>

      {loading
        ? <div style={{ textAlign: 'center', padding: 60 }}><span className="loading-spinner" /></div>
        : <>
          <div className="stats-grid">
            <S label="Šiandien žmonių"  value={stats?.today?.human}   sub="Axis: human"       color="#3b82f6" icon="🚶" />
            <S label="Šiandien aut."    value={stats?.today?.car}     sub="Axis: car"         color="#10b981" icon="🚗" />
            <S label="Savaitę žmonių"   value={stats?.week?.human}  sub="7 dienų srautas"  color="#8b5cf6" icon="📅" />
            <S label="Savaitę aut."      value={stats?.week?.car}    sub="7 dienų srautas"  color="#06b6d4" icon="🚕" />
            <S label="Mėnesį žmonių"    value={stats?.month?.human}   sub="30 dienų srautas"  color="#f59e0b" icon="📊" />
            <S label="Mėnesį aut."      value={stats?.month?.car}     sub="30 dienų srautas"  color="#06b6d4" icon="🚕" />
            <S label="Aktyvios kameros" value={stats?.activeCameras}  sub="Axis kamerų"       color="#ef4444" icon="📷" />
          </div>
          {chartData && <>
            <TimeSeriesChart data={chartData.timeSeries} title="📈 Srauto dinamika (30 d.) – Axis AOA" type="area" />
            <div className="charts-grid">
              <CameraCompareChart data={chartData.perCamera} title="📷 Srautas pagal kamerą" />
            </div>
          </>}
        </>
      }
    </div>
  );
}

function S({ label, value, sub, color, icon }) {
  return (
    <div className="stat-card">
      <div className="stat-icon" style={{ color }}>{icon}</div>
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={{ color }}>{(value || 0).toLocaleString()}</div>
      <div className="stat-sub">{sub}</div>
    </div>
  );
}